export const sidebarConstants = {
  SIDEBAR_ON: "SHOW_SIDEBAR",
  SIDEBAR_OFF: "HIDE_SIDEBAR"
};



// WEBPACK FOOTER //
// ./src/_constants/sidebar.constants.js